import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Artifacts() {
  return <ImageCollectionPage title="Artifacts" path="/culture/artifacts" collection="culture_artifacts" />;
}
